export default __webpack_public_path__ + "static/media/powered.0abbd28c.png";